<template>
  <div class="user-info-page">
    <el-card class="content-card" shadow="hover">
      <el-descriptions
        class="info-descriptions"
        :column="2"
        border
        :label-width="110"
        size="medium"
      >
        <!-- 用户名 -->
        <el-descriptions-item label="用户名" :span="1">
          <div class="field-value-display" @click="openInputPopup('mem_dian', '用户名', shopInfo.mem_dian, 100)">
            <span v-if="shopInfo.mem_dian" class="field-value-text">{{ shopInfo.mem_dian }}</span>
            <span v-else class="field-value-placeholder">请输入用户名</span>
            <i class="el-icon-edit-outline field-edit-icon"></i>
          </div>
        </el-descriptions-item>

        <!-- 手机号 -->
        <el-descriptions-item label="手机号" :span="1">
          <div class="field-value-display" @click="openInputPopup('mem_user', '手机号', shopInfo.mem_user, 11, 'tel')">
            <span v-if="shopInfo.mem_user" class="field-value-text">{{ shopInfo.mem_user }}</span>
            <span v-else class="field-value-placeholder">请输入手机号</span>
            <i class="el-icon-edit-outline field-edit-icon"></i>
          </div>
        </el-descriptions-item>

        <!-- 头像 -->
        <el-descriptions-item label="头像" :span="2">
          <div class="upload-container">
            <el-upload
              class="avatar-uploader"
              action=""
              :http-request="(options) => handleAvatarUpload(options)"
              :before-upload="(file) => beforeAvatarUpload(file)"
              :show-file-list="false"
              accept="image/*"
            >
              <img v-if="shopInfo.mem_img" :src="shopInfo.mem_img" class="avatar-preview" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">
              <span>仅支持图片，大小不超过 2MB</span>
              <span v-if="uploadLoading" class="uploading-text">上传中…</span>
            </div>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="公司名称(选填)" :span="2">
          <div class="field-value-display" @click="openInputPopup('comlist_v9', '公司名称', shopInfo.comlist_v9, 100)">
            <span v-if="shopInfo.comlist_v9" class="field-value-text">{{ shopInfo.comlist_v9 }}</span>
            <span v-else class="field-value-placeholder">请输入公司名称</span>
            <i class="el-icon-edit-outline field-edit-icon"></i>
          </div>
        </el-descriptions-item>

        <!-- 会员地址 -->
        <el-descriptions-item label="会员地址" :span="2">
          <div class="field-value-display" @click="openInputPopup('comlist_v2', '会员地址', shopInfo.comlist_v2, 200, 'textarea')">
            <span v-if="shopInfo.comlist_v2" class="field-value-text">{{ shopInfo.comlist_v2 }}</span>
            <span v-else class="field-value-placeholder">请输入会员地址</span>
            <i class="el-icon-edit-outline field-edit-icon"></i>
          </div>
        </el-descriptions-item>
      </el-descriptions>

      <div class="action-buttons">
        <el-button type="primary" size="medium" :loading="isSubmitting" @click="submitUserInfo">
          {{ isSubmitting ? '提交中...' : '确认' }}
        </el-button>
      </div>
    </el-card>

    <!-- 输入弹窗 -->
    <el-dialog
      :title="inputPopupTitle"
      :visible.sync="inputDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-input
        v-if="inputPopupType !== 'textarea'"
        v-model="inputPopupValue"
        :placeholder="'请输入' + inputPopupTitle"
        :maxlength="inputPopupMaxLength"
        :type="getInputType(inputPopupType)"
        clearable
        show-word-limit
      />
      <el-input
        v-else
        v-model="inputPopupValue"
        type="textarea"
        :placeholder="'请输入' + inputPopupTitle"
        :maxlength="inputPopupMaxLength"
        :rows="4"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeInputPopup">取消</el-button>
        <el-button type="primary" @click="confirmInputPopup">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import xcxrequest from '@/utils/xcxrequest'

export default {
  name: 'UserInfo',
  data () {
    return {
      // 弹窗相关
      inputDialogVisible: false,
      inputPopupTitle: '',
      inputPopupValue: '',
      inputPopupField: '',
      inputPopupMaxLength: 0,
      inputPopupType: 'text', // text | tel | textarea

      // 用户信息
      shopInfo: {
        mem_img: '',
        mem_dian: '',
        mem_user: '',
        comlist_v2: '',
        comlist_v9: ''
      },

      // 上传状态
      uploadLoading: false,
      isSubmitting: false,
      isLoading: false
    }
  },

  mounted () {
    this.fetchUserInfo()
  },

  methods: {
    // ========== 获取用户信息 ==========
    async fetchUserInfo () {
      this.isLoading = true

      try {
        const res = await xcxrequest.post('/admin/csh_jiben_details.php', { crm_id: localStorage.getItem('crm_id') })
        console.log(res)
        if (res.code === 0) {
          const raw = res.data
          const detail = raw.shopName ? raw.shopName[0] : raw
          this.shopInfo = {
            ...this.shopInfo,
            ...detail
          }
          // 同步缓存
          if (this.shopInfo.mem_dian) {
            localStorage.setItem('shop_name', this.shopInfo.mem_dian)
          }
          if (this.shopInfo.mem_img) {
            localStorage.setItem('shop_img', this.shopInfo.mem_img)
          }
        } else {
          this.$message.error(res.data?.msg || '获取用户信息失败')
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        this.$message.error('网络错误，请重试')
      } finally {
        this.isLoading = false
      }
    },

    // ========== 头像上传 ==========
    beforeAvatarUpload (file) {
      const isImage = file.type.startsWith('image/')
      const isLtSize = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLtSize) {
        this.$message.error('图片大小不能超过 2MB')
        return false
      }
      return true
    },

    async handleAvatarUpload (options) {
      const file = options.file
      const crmId = localStorage.getItem('crm_id') || ''
      const userPhone = localStorage.getItem('user_name') || ''
      const token = localStorage.getItem('token')

      const formData = new FormData()
      formData.append('file', file)
      formData.append('crm_id', crmId)
      formData.append('user_phone', userPhone)
      console.log(formData)
      const uploadUrl = 'https://caixiao.lianglianyn.com/index/upload_xdian.php'
      this.uploadLoading = true
      try {
        const res = await axios.post(
          uploadUrl,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              comlistToken: token
            }
          }
        )
        console.log(res)
        if (res.data && res.data.code === 0) {
          const imgUrl = res.data.yasuo_url || res.data.url
          if (imgUrl) {
            this.shopInfo.mem_img = imgUrl
            localStorage.setItem('shop_img', imgUrl)
            this.$message.success('头像上传成功')
          } else {
            this.$message.error('上传失败：未获取到图片地址')
          }
        } else {
          this.$message.error(res.data?.msg || '上传失败')
        }
      } catch (error) {
        console.error('上传失败:', error)
        this.$message.error('网络错误，请重试')
      } finally {
        this.uploadLoading = false
      }
    },

    // ========== 弹窗输入 ==========
    openInputPopup (field, title, value, maxLength = 50, type = 'text') {
      this.inputPopupField = field
      this.inputPopupTitle = title
      this.inputPopupValue = value || ''
      this.inputPopupMaxLength = maxLength
      this.inputPopupType = type
      this.inputDialogVisible = true
    },

    closeInputPopup () {
      this.inputDialogVisible = false
    },

    confirmInputPopup () {
      // 手机号校验
      if (this.inputPopupField === 'mem_user') {
        const val = this.inputPopupValue.trim()
        if (val && !/^1[3-9]\d{9}$/.test(val)) {
          this.$message.error('请输入正确的手机号')
          return
        }
      }

      this.shopInfo[this.inputPopupField] = this.inputPopupValue.trim()
      this.closeInputPopup()
    },

    getInputType (type) {
      switch (type) {
        case 'tel':
          return 'number'
        case 'idcard':
          return 'text'
        case 'textarea':
          return 'textarea'
        default:
          return 'text'
      }
    },

    // ========== 提交 ==========
    async submitUserInfo () {
      // 必填校验
      if (!this.shopInfo.mem_dian || !this.shopInfo.mem_dian.trim()) {
        this.$message.error('请输入用户名')
        return
      }
      if (!this.shopInfo.mem_user || !this.shopInfo.mem_user.trim()) {
        this.$message.error('请输入手机号')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.shopInfo.mem_user.trim())) {
        this.$message.error('请输入正确的手机号')
        return
      }

      this.isSubmitting = true

      try {
        const params = {
          crm_id: localStorage.getItem('crm_id'),
          mem_dian: this.shopInfo.mem_dian.trim(),
          mem_user: this.shopInfo.mem_user.trim(),
          mem_img: this.shopInfo.mem_img || '',
          comlist_v2: this.shopInfo.comlist_v2?.trim() || '',
          comlist_v9: this.shopInfo.comlist_v9?.trim() || ''
        }

        const res = await xcxrequest.post('/admin/csh_jiben_add.php', params)
        if (res.code === 0) {
          this.$message.success('保存成功')
          localStorage.setItem('user_name', this.shopInfo.mem_dian.trim())
          // 跳转到仪表盘（按需调整）
        //   this.$router.push('/dashboard')
        } else {
          this.$message.error(res.data?.msg || '保存失败，请重试')
        }
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error('网络错误，请重试')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-info-page {
  background-color: #f0f2f5;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
}

.content-card {
  margin: 0 auto;
  max-width: 900px;

  .el-card__body {
    padding: 20px 30px;
  }
}

.info-descriptions {
  .el-descriptions__body .el-descriptions__table {
    table-layout: fixed;
  }

  // 字段值点击区域
  .field-value-display {
    display: flex;
    align-items: center;
    min-height: 32px;
    padding: 0 4px;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: #f5f7fa;
    }

    .field-value-text {
      flex: 1;
      font-size: 14px;
      color: #333;
      word-break: break-all;
    }

    .field-value-placeholder {
      flex: 1;
      color: #bbb;
      font-size: 14px;
    }

    .field-edit-icon {
      color: #909399;
      margin-left: 8px;
      font-size: 16px;
      flex-shrink: 0;
    }
  }

  // 头像上传区域
  .upload-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    .avatar-uploader {
      .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: border-color 0.3s;
        overflow: hidden;
        background: #fafafa;

        &:hover {
          border-color: #409eff;
        }

        .avatar-preview {
          width: 100px;
          height: 100px;
          object-fit: cover;
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
        }
      }
    }

    .upload-tip {
      font-size: 12px;
      color: #909399;
      display: flex;
      align-items: center;
      gap: 12px;

      .uploading-text {
        color: #409eff;
      }
    }
  }
}

.action-buttons {
  margin-top: 24px;
  text-align: center;

  .el-button {
    width: 200px;
  }
}

.dialog-footer {
  .el-button {
    min-width: 80px;
  }
}
</style>
